/**
 * Feel Awsm * Meno Balance Funnel
 * Cart pattern adopted from proven Electrolyte funnel implementation.
 *   - Uses Shopify routes.cart_add_url
 *   - Sections requested in same POST body (no extra round-trip)
 *   - Selling-plan items via XHR (Shopify quirk for some themes)
 *   - PUB_SUB_EVENTS for cartUpdate / cartError
 *   - Proper aria-busy / aria-disabled / focus management
 * Funnel-specific features preserved: scroll reveal, FAQ <details> accordion,
 * sticky cart show/hide, "show all ingredients" toggle, menopause-burden calculator
 * (reads result HTML from data-res-* attributes for Translate & Adapt support).
 */
(function () {
    "use strict";

    if (window.__feelawsmKemInitialized) return;
    window.__feelawsmKemInitialized = true;

    var ROOT_ID = "feelawsm-menopause-funnel";
    var root = document.getElementById(ROOT_ID);
    if (!root) {
        // fallback — works even if liquid root has only the .kem-funnel class
        root = document.querySelector(".kem-funnel");
    }
    if (!root) return;

    document.documentElement.classList.add("kem-js");

    var funnelCfg = {};
    var cfgEl = document.getElementById("FeelawsmMenopauseFunnelConfig");
    if (cfgEl && cfgEl.textContent) {
        try { funnelCfg = JSON.parse(cfgEl.textContent); }
        catch (e) { funnelCfg = {}; }
    }
    var addingLabel =
        funnelCfg && typeof funnelCfg.addingLabel === "string" && funnelCfg.addingLabel
            ? funnelCfg.addingLabel
            : "Adding\u2026";

    /* ============ SCROLL REVEAL ============ */
    var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add("kem-in");
                revealObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" });
    root.querySelectorAll(".kem-reveal").forEach(function (el) {
        revealObserver.observe(el);
    });

    /* ============ FAQ ACCORDION (one open at a time) ============ */
    var faqItems = root.querySelectorAll(".kem-faq-item");
    faqItems.forEach(function (item) {
        item.addEventListener("toggle", function () {
            if (item.open) {
                faqItems.forEach(function (other) {
                    if (other !== item && other.open) other.open = false;
                });
            }
        });
    });

    /* ============ STICKY CART SHOW/HIDE ============ */
    var sticky = root.querySelector("#kem-sticky") || document.getElementById("kem-sticky");
    var hero = root.querySelector(".kem-hero");
    var ticking = false;
    window.addEventListener("scroll", function () {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                var y = window.scrollY;
                var threshold = hero ? (hero.offsetTop + hero.offsetHeight - 120) : 600;
                if (sticky) {
                    if (y > threshold) sticky.classList.add("kem-show");
                    else sticky.classList.remove("kem-show");
                }
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    /* ============ INGREDIENTS "SHOW ALL" TOGGLE ============ */
    var blocksToggle = root.querySelector(".kem-blocks-toggle button");
    var blocksWrap = root.querySelector(".kem-blocks");
    if (blocksToggle && blocksWrap) {
        blocksToggle.addEventListener("click", function () {
            var open = blocksWrap.classList.toggle("kem-show-all");
            blocksToggle.textContent = open
                ? (blocksToggle.dataset.lessLabel || "Show fewer ingredients \u2191")
                : (blocksToggle.dataset.moreLabel || "See all 15 ingredients \u2193");
        });
    }

    /* ============ MENOPAUSE BURDEN CALCULATOR ============ */
    var calcBtn = root.querySelector(".kem-calc-btn");
    if (calcBtn) {
        calcBtn.addEventListener("click", function () {
            var ageInput = root.querySelector("#kem-calc-age");
            var age = parseInt(ageInput && ageInput.value, 10) || 48;
            var stage = (root.querySelector('input[name="kem-stage"]:checked') || {}).value || "peri";
            var flashEl = root.querySelector("#kem-calc-flash");
            var flash = (flashEl && flashEl.value) || "sometimes";
            var sleepEl = root.querySelector("#kem-calc-sleep");
            var sleep = (sleepEl && sleepEl.value) || "ok";
            var stressEl = root.querySelector("#kem-calc-stress");
            var stress = (stressEl && stressEl.value) || "medium";
            var supp = (root.querySelector('input[name="kem-supp"]:checked') || {}).value || "no";

            var base = 100 - Math.max(0, (age - 35) * 1.2);
            if (stage === "peri") base -= 8;
            if (stage === "meno") base -= 15;
            if (stage === "post") base -= 6;
            if (flash === "sometimes") base -= 4;
            if (flash === "daily") base -= 12;
            if (flash === "hourly") base -= 22;
            if (sleep === "ok") base -= 4;
            if (sleep === "poor") base -= 12;
            if (sleep === "bad") base -= 20;
            if (stress === "medium") base -= 5;
            if (stress === "high") base -= 13;
            if (supp === "yes") base += 5;
            base = Math.max(15, Math.min(100, Math.round(base)));

            var scoreEl = root.querySelector("#kem-result-score");
            var catEl = root.querySelector("#kem-result-cat");
            var msgEl = root.querySelector("#kem-result-msg");
            var fillEl = root.querySelector("#kem-prog-fill");
            var panel = root.querySelector("#kem-result");

            if (scoreEl) scoreEl.textContent = base + "%";
            if (fillEl) {
                fillEl.style.width = base + "%";
                if (base >= 75)      fillEl.style.background = "linear-gradient(90deg,#5A8A5A,#7AB87A)";
                else if (base >= 55) fillEl.style.background = "linear-gradient(90deg,#C4973A,#E8C06A)";
                else                 fillEl.style.background = "linear-gradient(90deg,#B8446A,#E890B0)";
            }

            /* Read translated result HTML from widget data-res-* attributes */
            var widget = root.querySelector(".kem-calc-widget");
            var d = (widget && widget.dataset) || {};
            var resHtml;
            if (base >= 80) {
                resHtml = d.resLow  || '<span class="kem-result-cat-inline">\uD83D\uDFE2 Low cortisol burden</span> Your cortisol load is still manageable. Acting now keeps it that way.';
            } else if (base >= 65) {
                resHtml = d.resMod  || '<span class="kem-result-cat-inline">\uD83D\uDFE1 Moderate cortisol burden</span> Early signs are real. Meno Balance breaks the loop before symptoms compound.';
            } else if (base >= 50) {
                resHtml = d.resHigh || '<span class="kem-result-cat-inline">\uD83D\uDFE0 High cortisol burden</span> The Thermo-Cortisol Loop is active. Both pillars need support now.';
            } else {
                resHtml = d.resCrit || '<span class="kem-result-cat-inline">\uD83D\uDD34 Critical cortisol burden</span> Cortisol is dominating your day and night. The full system addresses both pillars at full doses.';
            }

            if (catEl) catEl.textContent = "";
            if (msgEl) msgEl.innerHTML = resHtml;
            if (panel) {
                panel.classList.add("kem-show");
                panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        });
    }

    /* ============ SHOPIFY ADD-TO-CART INTEGRATION ============
     * Adopted from proven Electrolyte funnel cart pattern.
     */
    function getCartUi() {
        return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }

    function getCartAddUrl() {
        var cartAddPath =
            typeof routes !== "undefined" && routes.cart_add_url
                ? String(routes.cart_add_url)
                : "/cart/add";
        if (cartAddPath.indexOf("/") === 0 && cartAddPath.indexOf("cart") !== -1) {
            return cartAddPath.replace(/\/cart\/add\/?$/, "/cart/add.js");
        }
        return "/cart/add.js";
    }

    function parseQuantity(btn) {
        var q = parseInt(btn.getAttribute("data-quantity"), 10);
        if (!isNaN(q) && q > 0) return q;
        return 1;
    }

    function fetchSectionHtmlForCart(cart, data, doRender) {
        if (data.sections || !cart || typeof routes === "undefined" || !routes.cart_url) {
            doRender(data);
            return Promise.resolve();
        }
        var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
        return Promise.all(
            sectionIds.map(function (id) {
                return fetch(routes.cart_url + "?section_id=" + id, { cache: "no-store" })
                    .then(function (r) { return r.text(); });
            })
        ).then(function (htmls) {
            var sections = {};
            sectionIds.forEach(function (id, i) { sections[id] = htmls[i]; });
            doRender(Object.assign({}, data, { sections: sections }));
        }).catch(function () {
            doRender(data);
        });
    }

    root.querySelectorAll(".js-feelawsm-funnel-atc").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            if (btn.getAttribute("aria-disabled") === "true") return;

            var cart = getCartUi();
            var vid = parseInt(btn.getAttribute("data-variant-id"), 10);
            var spRaw = btn.getAttribute("data-selling-plan") || "";
            var quantity = parseQuantity(btn);

            if (!vid || isNaN(vid)) {
                alert("Missing variant");
                return;
            }

            var sellingPlanId = null;
            if (String(spRaw).trim() !== "") {
                var spNum = parseInt(spRaw, 10);
                if (!isNaN(spNum)) sellingPlanId = spNum;
            }

            var item = { id: vid, quantity: quantity };
            if (sellingPlanId != null) item.selling_plan = sellingPlanId;

            var body = { items: [item] };
            if (cart) {
                if (typeof cart.setActiveElement === "function") {
                    cart.setActiveElement(document.activeElement);
                }
                if (sellingPlanId == null) {
                    body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
                    body.sections_url = window.location.pathname;
                }
            }

            var addUrl = getCartAddUrl();
            var bodyString = JSON.stringify(body);

            var previousHtml = btn.innerHTML;
            btn.innerHTML = "";
            btn.appendChild(document.createTextNode(addingLabel));
            btn.classList.add("feelawsm-funnel-atc--loading");
            btn.setAttribute("aria-busy", "true");
            btn.setAttribute("aria-disabled", "true");

            var cartAddPromise =
                sellingPlanId != null
                    ? new Promise(function (resolve, reject) {
                        var xhr = new XMLHttpRequest();
                        xhr.open("POST", addUrl, true);
                        xhr.setRequestHeader("Content-Type", "application/json");
                        xhr.setRequestHeader("Accept", "application/json");
                        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                        xhr.onload = function () {
                            if (xhr.status < 200 || xhr.status >= 400) {
                                reject(new Error("Cart add failed: " + xhr.status));
                                return;
                            }
                            try { resolve(JSON.parse(xhr.responseText)); }
                            catch (err) { reject(err); }
                        };
                        xhr.onerror = function () {
                            reject(new Error("Cart add network error"));
                        };
                        xhr.send(bodyString);
                    })
                    : fetch(addUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                        },
                        body: bodyString,
                    }).then(function (response) {
                        if (!response.ok) throw new Error("Cart add failed: " + response.status);
                        return response.json();
                    });

            cartAddPromise
                .then(function (response) {
                    if (response.status) {
                        if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                            publish(window.PUB_SUB_EVENTS.cartError, {
                                source: "feelawsm-menopause-funnel",
                                productVariantId: String(vid),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                        }
                        var desc = (response.description || response.message || "Could not add to cart").toString();
                        alert(desc);
                        return;
                    }

                    if (!cart) {
                        if (typeof routes !== "undefined" && routes.cart_url) {
                            window.location.href = routes.cart_url;
                        } else {
                            window.location.href = "/cart";
                        }
                        return;
                    }

                    if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                        publish(window.PUB_SUB_EVENTS.cartUpdate, {
                            source: "feelawsm-menopause-funnel",
                            productVariantId: String(vid),
                            cartData: response,
                        });
                    }
                    window.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

                    var doRender = function (data) {
                        cart.renderContents(data);
                    };

                    if (cart.classList && cart.classList.contains("is-empty")) {
                        cart.classList.remove("is-empty");
                    }

                    return fetchSectionHtmlForCart(cart, response, doRender);
                })
                .catch(function (err) {
                    console.warn("[feelawsm-meno]", err);
                    var msg = (err && err.message) || "Could not add to cart";
                    alert(msg);
                })
                .finally(function () {
                    btn.innerHTML = previousHtml;
                    btn.classList.remove("feelawsm-funnel-atc--loading");
                    btn.removeAttribute("aria-busy");
                    btn.removeAttribute("aria-disabled");
                });
        });
    });

    /* ============ SMOOTH ANCHOR SCROLL (offset for sticky bar) ============ */
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener("click", function (e) {
            var href = link.getAttribute("href");
            if (!href || href.length < 2) return;
            var target = document.querySelector(href);
            if (!target) return;
            e.preventDefault();
            var top = target.getBoundingClientRect().top + window.scrollY - 60;
            window.scrollTo({ top: top, behavior: "smooth" });
        });
    });
})();
